import { StateRepository } from '@angular-ru/ngxs/decorators';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State, StateToken, Store } from '@ngxs/store';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';
import {
    IProductCategoryContext,
    IProductContextAssessmentStatus,
    IProductContextCase,
    IProductContextCaseStatus,
    IProductContextMetadataOwner,
    IProductInterviewConfig,
    IProductSmartActionReference,
    IProductStage,
} from 'src/app/models/case';
import { INotification } from 'src/app/models/notifications';
import { Product } from 'src/app/models/product';
import { SignalREvent } from 'src/app/models/signalr';
import { IDisqualificationReason, IInterviewHandler } from 'src/app/shared/interview-new/models/interview-handler.models';
import { InterviewHandlerService } from 'src/app/shared/interview-new/services/interview-handler.service';
import { FeatureService } from 'src/app/shared/preview-feature/preview-feature.service';

import { TaskOrchestratorService } from 'src/app/services/task-orchestrator/task-orchestrator.service';
import { BaseProductServiceSingle } from '../-base-product.service-single';
import { CaseService } from '../../case/case.service';
import { interviewLISDataProviderToken } from '../../interview-providers/interview-data-provider.tokens';
import { MemberService } from '../../member/member.service';
import { ProductContextService } from '../../product-context/product-context.service';
import { TaskServiceFactory, TaskServiceFactoryFn } from '../../task/task.service';
import { UserService } from '../../user/user.service';
import { AlertService } from './../../alert.service';
import { GlobalService } from './../../global/global.service';
import { LISInterviewData } from './lis-interview-data';
import { LISStateModel } from './lis.state.models';

export const LIS_TOKEN_KEY = 'lisState';
export const LIS_TOKEN_TOKEN = new StateToken<LISService>(LIS_TOKEN_KEY);


@StateRepository()
@State<LISStateModel>({
    name: LIS_TOKEN_TOKEN,
    defaults: {

    }
})
@Injectable()
export class LISService extends BaseProductServiceSingle<LISStateModel> {
    get stateToken() {
        return LIS_TOKEN_TOKEN;
    }

    //get status$(): Observable<IProductContextCaseStatus> {
    //    return this.store.select<IProductContextCaseStatus>(LISService.status);
    //}

    // get statusSync(): IProductContextCaseStatus {
    //     return this.store.selectSnapshot<IProductContextCaseStatus>(LISService.status(this));
    // }

    // get caseOwner$(): Observable<IProductContextMetadataOwner> {
    //     return this.store.select<IProductContextMetadataOwner>(LISService.owner(this));
    // }

    // get caseOwnerSync(): IProductContextMetadataOwner {
    //     return this.store.selectSnapshot<IProductContextMetadataOwner>(LISService.owner(this));
    // }

    // get sourceProduct$(): Observable<Product> {
    //     return this.store.select<Product>(LISService.sourceProduct(this));
    // }

    // get productCategoryContext$(): Observable<IProductCategoryContext> {
    //     return this.store.select<IProductCategoryContext>(LISService.productCategoryContext(this));
    // }

    // get productCategoryContextSync(): IProductCategoryContext {
    //     return this.store.selectSnapshot<IProductCategoryContext>(LISService.productCategoryContext(this));
    // }

    // get metadataSync(): any {
    //     return this.store.selectSnapshot<IProductContextCase>(LISService.metadata(this));
    // }
    // get metadata$(): Observable<any> {
    //     return this.store.select<any>(LISService.metadata);
    // }

    // get currentCaseSync(): IProductContextCase {
    //     return this.store.selectSnapshot<IProductContextCase>(LISService.currentCase(this));
    // }
    // get currentCase$(): Observable<IProductContextCase> {
    //     return this.store.select<IProductContextCase>(LISService.currentCase(this));
    // }


    // get iconSync(): string {
    //     return this.store.selectSnapshot<string>(LISService.icon(this));
    // }
    // get icon$(): Observable<string> {
    //     return this.store.select<string>(LISService.icon(this));
    // }

    // get noCaseMessageSync(): string {
    //     return this.store.selectSnapshot<string>(LISService.noCaseMessage(this));
    // }
    // get noCaseMessage$(): Observable<string> {
    //     return this.store.select<string>(LISService.noCaseMessage(this));
    // }

    // get categoryDisplayNameSync(): string {
    //     return this.store.selectSnapshot<string>(LISService.categoryDisplayName(this));
    // }
    // get categoryDisplayName$(): Observable<string> {
    //     return this.store.select<string>(LISService.categoryDisplayName(this));
    // }

    // get caseStageSync(): IProductStage {
    //     return this.store.selectSnapshot<IProductStage>(LISService.caseStage(this));
    // }
    // get caseStage$(): Observable<IProductStage> {
    //     return this.store.select<IProductStage>(LISService.caseStage(this));
    // }


    // get notifications$(): Observable<INotification[]> {
    //     return this.store.select<INotification[]>(LISService.notifications(this));
    // }

    // get productInterviewsSync(): IProductInterviewConfig[] {
    //     return this.store.selectSnapshot<IProductInterviewConfig[]>(LISService.productInterviews(this));
    // }

    // get productInterviews$(): Observable<IProductInterviewConfig[]> {
    //     return this.store.select<IProductInterviewConfig[]>(LISService.productInterviews(this));
    // }

    // get caseAssessmentSync(): IProductContextAssessmentStatus {
    //     return this.store.selectSnapshot<IProductContextAssessmentStatus>(LISService.caseAssessment(this));
    // }
    // get caseAssessment$(): Observable<IProductContextAssessmentStatus> {
    //     return this.store.select<IProductContextAssessmentStatus>(LISService.caseAssessment(this));
    // }

    // get stagesSync(): IProductStage[] {
    //     return this.store.selectSnapshot<IProductStage[]>(LISService.stages(this));
    // }
    // get stages$(): Observable<IProductStage[]> {
    //     return this.store.select<IProductStage[]>(LISService.stages(this));
    // }

    // get smartActionsSync(): IProductSmartActionReference[] {
    //     return this.store.selectSnapshot<IProductSmartActionReference[]>(LISService.smartActions(this));
    // }
    // get smartActions$(): Observable<IProductSmartActionReference[]> {
    //     return this.store.select<IProductSmartActionReference[]>(LISService.smartActions(this));
    // }



    get interviewDataProviderToken() {
        return interviewLISDataProviderToken;
    }


    constructor(
        globalService: GlobalService,
        memberService: MemberService,
        userService: UserService,
        caseService: CaseService,
        productContextService: ProductContextService,
        confirmationService: ConfirmationService,
        router: Router,
        route: ActivatedRoute,
        alertService: AlertService,
        store: Store,
        featureService: FeatureService,
        taskOrchestratorService: TaskOrchestratorService,
        @Inject(TaskServiceFactory) taskService: TaskServiceFactoryFn

    ) {
        super(
            'LIS',
            memberService,
            userService,
            caseService,
            productContextService,
            confirmationService,
            router,
            route,
            alertService,
            LISInterviewData,
            store,
            featureService,
            new InterviewHandlerService(),
            taskOrchestratorService
        );

        this.taskService = taskService().setContext();
        this.taskService.activate();
    }


    signalRFilter(event: SignalREvent): boolean {
        return true;
    }

    protected isProductDisabled(): boolean {
        return false;
    }

    async canInterviewAdvanceStage(status: string, disqualificationReason: IDisqualificationReason, interviewHandler: IInterviewHandler) {
        const result = disqualificationReason != null || ('Eligibility' === this.caseStageSync.name);
        return result;
    }


}
